import Meta from '@/components/common/Meta'

import { META_CONTENTS } from '@/v1/constants/seo'
import CollegeStudentShippingPage from '@/v2/components/pages/public-pages/college-student-shipping-page'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/college-student-shipping-page'

interface CollegeStudentShippingPageProps {}

const Page: React.FC<CollegeStudentShippingPageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.college_student_shipping.title ?? ''}
        keywords={META_CONTENTS.college_student_shipping?.keywords ?? ''}
        description={META_CONTENTS.college_student_shipping?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <CollegeStudentShippingPage />
    </>
  )
}

export default Page
